import { useStaffGetPublicHolidays } from '@urbanx/agx.agencies.client';
import { Dayjs } from 'dayjs';
import { useCallback } from 'react';

const isWeekend = (date: Dayjs): boolean => {
  const day = date.day();
  // day() returns 0-6 where Sunday=0, Saturday=6
  return day === 0 || day === 6;
};

export const useBusinessDate = (state: string) => {
  const { data: publicHolidays } = useStaffGetPublicHolidays(state);

  const isNonBusinessDay = useCallback(
    (date: Dayjs): boolean => {
      if (isWeekend(date)) {
        return true;
      }
      if (publicHolidays) {
        return publicHolidays.some((holiday) => date.isSame(holiday.date, 'day'));
      }
      return false;
    },
    [publicHolidays]
  );

  const moveToNextBusinessDay = useCallback(
    (date: Dayjs): Dayjs => {
      let result = date;
      while (isNonBusinessDay(result)) {
        result = result.add(1, 'day');
      }
      return result;
    },
    [isNonBusinessDay]
  );

  const addBusinessDays = useCallback(
    (startDate: Dayjs, days: number): Dayjs => {
      let result = startDate;
      let remainingDays = Math.abs(days);
      const direction = days >= 0 ? 1 : -1;

      while (remainingDays > 0) {
        result = result.add(direction, 'day');
        if (!isNonBusinessDay(result)) {
          remainingDays--;
        }
      }

      return result;
    },
    [isNonBusinessDay]
  );

  return {
    isNonBusinessDay,
    moveToNextBusinessDay,
    addBusinessDays,
  };
};
